import { Spin } from "antd";
import PageHeader from "components/PageHeader";
import { CAMPAIGN_TYPE } from "features/Campaign/constants";
import { t } from "i18next";
import CampaignForm from "../Form";
import CashDiscountForm from "../Form/CashDiscountForm";
import useEditForm from "./useEditForm";

const EditForm = () => {
  const {
    form,
    id,
    handleUpdateClick,
    buttonGroupAction,
    data,
    isApplyWithPromotion,
    handleValuesChange,
    handleCheckIsApplyWithPromo,
    promotionCampaignTiers,
    visibleConfirmModal,
    handleOpenConfirmModal,
    handleCancelConfirmModal,
    dataConfirmModal,
    loadingDataUpdate,
    initValues,
    loadingAll,
    GET_QUERY,
  } = useEditForm();

  const pageTitle = () => {
    switch (GET_QUERY.campaignType) {
      case CAMPAIGN_TYPE.COMBO_PROMO:
        return "Cập nhật khuyến mãi theo combo";
      case CAMPAIGN_TYPE.TOP_SALES:
        return "Cập nhật khuyến mãi đua top";
      case CAMPAIGN_TYPE.PRODUCT_PROMO:
        return "Cập nhật khuyến mãi trên 1 sản phẩm";
      case CAMPAIGN_TYPE.CASH_DISCOUNT:
      case "CASH_DISCOUNT":
        return "Cập nhật chiết khấu tiền mặt";
      case CAMPAIGN_TYPE.ORDER_PROMO:
        return "Cập nhật khuyến mãi trên 1 đơn hàng";
      case CAMPAIGN_TYPE.LUCKY_WHEEL:
        return "Cập nhật vòng quay may mắn";
      default:
        return "#";
    }
  };

  return (
    <Spin spinning={loadingAll || loadingDataUpdate}>
      <PageHeader
        pageTitle={pageTitle()}
        routes={[
          {
            path: "/campaign",
            name: t("campaign.form.list"),
          },
          {
            path: `/campaign/detail/${id}`,
            name: data?.name,
          },
        ]}
      />
      {GET_QUERY.campaignType === CAMPAIGN_TYPE.CASH_DISCOUNT || GET_QUERY.campaignType === "CASH_DISCOUNT" ? (
        <CashDiscountForm
          form={form}
          isUpdate={true}
          isEditMode={true}
          dataCampaign={data}
          isApplyWithPromotion={isApplyWithPromotion}
          handleValuesChange={handleValuesChange}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          promotionCampaignTiers={promotionCampaignTiers}
          handleActionCampaign={handleUpdateClick}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          dataConfirmModal={dataConfirmModal}
          loadingUpdate={loadingAll}
          createLoading={loadingAll}
        />
      ) : (
        <CampaignForm
          form={form}
          buttonGroupAction={buttonGroupAction}
          isUpdate={true}
          isEditMode={true}
          dataCampaign={data}
          isApplyWithPromotion={isApplyWithPromotion}
          handleValuesChange={handleValuesChange}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          promotionCampaignTiers={promotionCampaignTiers}
          handleActionCampaign={handleUpdateClick}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          dataConfirmModal={dataConfirmModal}
          loadingUpdate={loadingAll}
          dataTiersServer={initValues}
          initialValues={initValues}
        />
      )}
    </Spin>
  );
};

export default EditForm;
